import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "search-view"
}

import { getSearchContext } from '@/composables/useSearch';

import SearchViewPhone from './SearchViewPhone.vue';
import SearchViewDesktop from './SearchViewDesktop.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {


const { isSearchOpen, isMounted, isDesktop } = getSearchContext();


return (_ctx: any,_cache: any) => {
  return (_unref(isSearchOpen))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isMounted) && !_unref(isDesktop))
          ? (_openBlock(), _createBlock(SearchViewPhone, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(isMounted) && _unref(isDesktop))
          ? (_openBlock(), _createBlock(SearchViewDesktop, { key: 1 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})